import BigNumber from "bignumber.js";
const countries = require('../json/countries.json')

export default class Helper {
    constructor() {

    }

    is_id(id){
        if(!id) return false
        if(id.length==24) return true
        else return false
    }

    // поиск страны по коду
    get_country_by_iso(iso){
        if(!iso) return null
        let country = countries.find((item)=>{
            return item.iso == iso
        })
        if(country){
            return country
        }else{
            return null
        }
    }

    // поиск страны по валюте
    get_country_by_currency(currency){
        if(!currency) return null
        let country = countries.find((item)=>{
            return item.currency == currency
        })
        if(country){
            return country
        }else{
            return null
        }
    }

    // форматирует маску из # в 9
    format_mask(code){
        if(!code) return ''
        return code.replace(/#/g, '9')
    }

    get_currency_label(cur){
        let label
        switch (cur){
            case 'rub':
                label = '₽'
            break;
            case 'usd':
                label = '$'
            break;
            case 'eur':
                label = '€'
            break;
            case 'gbp':
                label = '£'
            break;
            case 'idr':
                label = 'IDR'
            break;
            case 'thb':
                label = 'THB'
            break;
            default:
                label = cur
            break;
        }
        return label
    }

    get_short_id(id){
        if(id){
            return id.substr(18, 6)
        }else{
            return id
        }
    }

    get_short_name(name, length=15){
        if(name) {
            if(name.length > length) return name.substr(0, length-3)+'...'
            else return name
        }
        else return name
    }

    get_payment_system_title(system){
        let label
        switch (system){
            case 'stock':
                label = 'Биржа'
            break;
            case 'atm':
                label = 'Банкомат'
            break;
            case 'card':
                label = 'Карта'
            break;
            case 'sbp':
                label = 'СБП'
            break;
            case 'courier':
                label = 'Курьер'
            break;
            case 'swift':
                label = 'SWIFT'
            break;
            default:
                label = system
            break;
        }
        return label
    }

    get_payment_type_label(system){
        let label
        switch (system){
            case 'payment_system':
                label = 'платежная система'
            break;
            case 'merchant':
                label = 'оплата мерчанту'
            break;
            case 'internal':
                label = 'внутренний счет'
            break;
            default:
                label = system
            break;
        }
        return label
    }

    get_token_label(token){
        let label
        switch (token){
            case 'ether':
                label = 'ETH'
            break;
            case 'tether':
                label = 'USDT'
            break;
            case 'testcoin':
                label = 'MTH'
            break;
            default:
                label = token
            break;
        }
        return label
    }

    get_transfer_type_class(type){
        switch (type){
            case 'transfer':
                return 'bg-primary border-round-md p-1 text-white'
            case 'topup':
                return 'bg-green-400 border-round-md p-1 text-white'
            case 'withdraw':
                return 'bg-yellow-400 border-round-md p-1 text-yellow-800'
            case 'bill':
                return 'bg-orange-400 border-round-md p-1 text-white'
            default:
                return ''
        }
    }

    get_transfer_type_label(type){
        switch (type){
            case 'transfer':
                return 'Перевод'
            case 'topup':
                return 'Пополнение'
            case 'withdraw':
                return 'Вывод'
            case 'bill':
                return 'Счет'
            default:
                return type
        }
    }

    get_transfer_type_icon(type){
        switch (type){
            case 'transfer':
                return 'pi pi-arrow-right-arrow-left'
            case 'topup':
                return 'pi pi-arrow-down'
            case 'withdraw':
                return 'pi pi-arrow-up'
            case 'bill':
                return 'pi pi-dollar'
            default:
                return type
        }
    }

    get_transfer_severity(type){
        switch (type){
            case 'transfer':
                return 'secondary'
            case 'topup':
                return 'success'
            case 'withdraw':
                return 'warning'
            case 'bill':
                return 'info'
            default:
                return ''
        }
    }

    getKycSeverity(status){
        if(!status) return 'secondary'
        switch (status) {
            case 'not_sent':
                return 'secondary';
            case 'pending':
                return 'info';
            case 'processing':
                return 'info';
            case 'approved':
                return 'success';
            case 'rejected':
                return 'danger';
            case 'completed':
                return 'success';
            default:
                return 'secondary';
        }
    }

    getKycStatus(status){
        if(!status) return 'Не проверен'
        switch (status) {
            case 'not_sent':
                return 'Не отправлен';
            case 'pending':
                return 'На рассмотрении';
            case 'processing':
                return 'В обработке';
            case 'approved':
                return 'Подтвержден';
            case 'rejected':
                return 'Отклонен';
            case 'completed':
                return 'Завершен';
            default:
                return status;
        }
    }
    
    // TODO: убрать
    // форматирование списка платежных систем
    formatPaymentSystems(array){
        if(!array) return []
        if(typeof array != 'object') return []
        if(array.length==0) return []
        let result = []
        array.forEach((item)=>{
            if(item.comissions==undefined) return false
            let item_obj = {
                code: (item.code) ? item.code : '',
                type: (item.code) ? item.type : '',
                titles: {
                    ru: (item.titles && item.titles.ru) ? item.titles.ru : '-',
                    en: (item.titles && item.titles.en) ? item.titles.en : '-'
                },
                description: {
                    ru: (item.descriptions && item.descriptions.ru) ? item.descriptions.ru : null,
                    en: (item.descriptions && item.descriptions.en) ? item.descriptions.en : null
                },
                comissions: {
                    percent: (item.comissions && item.comissions.percent) ? item.comissions.percent : 0,
                    fix: (item.comissions && item.comissions.fix) ? item.comissions.fix : 0
                },
                sort: (item.sort) ? item.sort : '',
                image: (item.image) ? item.image : '',
            }
            result.push(item_obj)
        })
        return result
    }

    formatBankList(object){
        if(!object) return []
        if(typeof object != 'object') return []
        if(object.length==0) return []
        let result = {}
        for (const [key, value] of Object.entries(object)) {
            if(value.comissions==undefined) continue
            if(value.limits==undefined) continue
            let obj_item = {
                code: key,
                titles: (value.titles) ? value.titles : {},
                description: (value.descriptions) ? value.descriptions : {},
                type: (value.type) ? value.type : null,
                image: (value.image) ? value.image : null,
                recipient_fields: (value.recipient_fields) ? value.recipient_fields : null,
                recipient_fields_required: (value.recipient_fields_required) ? value.recipient_fields_required : null,
                amount_list: (value.amount_list) ? value.amount_list : [],
                comissions: {
                    percent: (value.comissions && value.comissions.percent) ? value.comissions.percent : 0,
                    fix: (value.comissions && value.comissions.fix) ? value.comissions.fix : 0,
                },
                limits: {
                    min: (value.limits && value.limits.min) ? value.limits.min : 0,
                    max: (value.limits && value.limits.max) ? value.limits.max : 0,
                },
                time: (value.time) ? value.time : 0,
                sort: (value.sort) ? value.sort : 0,
            }
            result[key] = obj_item
        }
        return result
    }

    format_date(value){
        if(!value) return ''
        let date, year, month, day, hours, minutes, seconds;
        date = new Date(value);
        year = date.getFullYear();
        month = date.getMonth()+1;
        day = date.getDate();

        hours = date.getHours();
        minutes = date.getMinutes();
        seconds = date.getSeconds();

        if (day < 10) {
            day = '0' + day;
        }
        if (month < 10) {
            month = '0' + month;
        }

        if (hours < 10) {
            hours = '0' + hours;
        }

        if (minutes < 10) {
            minutes = '0' + minutes;
        }

        return `${day}.${month}.${year} ${hours}:${minutes}`
    }

    format_date_short(value, time=true){
        let date, year, month, day, hours, minutes, seconds;
        date = new Date(value);
        year = date.getFullYear();
        month = date.getMonth()+1;
        day = date.getDate();

        hours = date.getHours();
        minutes = date.getMinutes();
        seconds = date.getSeconds();

        if (day < 10) {
            day = '0' + day;
        }
        if (month < 10) {
            month = '0' + month;
        }

        if (hours < 10) {
            hours = '0' + hours;
        }

        if (minutes < 10) {
            minutes = '0' + minutes;
        }

        if(time) return `${day}.${month}.${year} ${hours}:${minutes}`
        if(!time) return `${day}.${month}.${year}`
        
    }

    format_amount(value, currency, digits=2){
        if(value==undefined || value==null || value==NaN) return null
        const val = new BigNumber(value)
        let num = val.toFixed(digits)
        if(val.isEqualTo(0)) num = '0'
        if(!num) return null
        if(currency==null) return num
        currency = currency.toLowerCase()

        let textCur = currency
        switch (currency){
            case 'usdt_bsc':
                textCur = 'USDTb'
            break;
            case 'usdt_erc':
                textCur = 'USDTe'
            break;
            case 'usdt_trc':
                textCur = 'USDTt'
            break;
            default:
                textCur = currency.toUpperCase()
            break;
        }

        if(num==0) return '0 ' + textCur

        try{
            if(currency && (currency == 'usdt' || currency == 'usdt_trc' || currency == 'usdt_bsc' || currency == 'usdt_erc')){
                return new Intl.NumberFormat('en-US').format(num, {minimumFractionDigits: digits}) + ' ' + textCur
            }
            return new Intl.NumberFormat('ru-RU', { style: 'currency', currency: currency, minimumFractionDigits: digits}).format(num)
        } catch (e) {
            return num+' '+textCur
        }
    }

    format_amount_nocur(value, digits=2){
        if(!value) return null
        const num = new BigNumber(value).toFixed(digits)
        if(!num) return null
        if(num==0) return 0

        try{
            return new Intl.NumberFormat('ru-RU', { style: 'decimal', currency: undefined, minimumFractionDigits: digits}).format(num)
        } catch (e) {
            return num
        }
    }

    split_num(num){
        const bNum = new BigNumber(num)
        if(bNum.isNaN()) return ''
        if(bNum.isGreaterThan(2)){
            const strNum = bNum.toFixed(0)
            return this.format_amount_nocur(strNum, 0)
        } else if(bNum.isLessThan(2)){
            const strNum = bNum.toFixed(2)
            return this.format_amount_nocur(strNum, 2)
        } else {
            const strNum = bNum.toFixed(1)
            return this.format_amount_nocur(strNum, 0)
        }
    }

    format_rate(value, num=2){
        if(!value) return null
        let rate = new BigNumber(value)
        if(rate.isNaN()) return 0
        if(rate.isZero()) return 0
        if(rate.isLessThan(0)) return 0
        if(rate.isLessThan(1)) return rate.toFixed(6)
        return rate.toFixed(num)
    }

    phone_mask(phone, cur_code='rub'){
        let mask = '+# (###) ###-###-###'
        switch (cur_code){
            case 'rub':
                mask = '+# (###) ###-###-###'
            break;
            case 'idr':
                //621111111111
                mask = '+## (###) ###-###-##'
            break;
            case 'thb':
                //66 (99) 999-99-99
                mask = '+## (##) ###-##-##'
            break;
            default:
                return phone
            break;
        }

        let i = 0, v = phone.toString();
        return mask.replace(/#/g, _ => v[i++])
    }

    get_reverce_rate(rate){
        if(!rate) return '-'
        if(typeof rate === 'string') rate = rate.replace(/,/g, '.')
        if(rate){
            if(rate==0) return null
            const b_rate1 = new BigNumber(1)
            const b_rate2 = new BigNumber(rate)
            const result = b_rate1.dividedBy(b_rate2)
            return (result.isLessThan(1)) ? result.toFixed(9) : result.toFixed(3)
        }else{
            return 0
        }
    }

    // проверка телефона на валидность
    checkPhoneValid(val){
        if(!val) return false
        const number = val.replace(/\D+/g,"")
        if(number.length < 8 || number.length > 15) return false
        return true
    }

    // проверка телефона только из цифр
    checkPhoneNumValid(val){
        if(!val) return false
        const number = val.toString()
        if(number.length < 8 || number.length > 15) return false
        return true
    }

    // с заглавных букв
    toUpperCase(val){
        if(!val) return ''
        return String(val).toUpperCase()
    }

    // проверка номера карты на валидность
    checkCardValid(val){
        if(!val) return false
        const number = val.replace(/\D+/g,"")
        if(number.length != 16) return false
        return true
    }

    // очистка номера от лишних символов
    cleanCardOrPhone(val){
        if(!val) return null
        return val.replace(/\D+/g,"")
    }

    get_field_icon(field){
        if(!field) return null
        switch (field){
            case 'fullname':
                return 'pi-user'
            case 'phone_number':
                return 'pi-phone'
            case 'card_number':
                return 'pi-credit-card'
            case 'account_number':
                return 'pi-id-card'
            case 'wallet_address':
                return 'pi-wallet'
            case 'telegram':
                return 'pi-telegram'
            
            // 'bank_name', 'address', 'city', 'country', 'swift_code', 'iban_number'
            case 'bank_name':
            default:
                return field
        }
    }

    // время в формате минуты:секунды
    get_timer(date1, date2){
        if(!date1) return null
        if(!date2) return null

        let hours = 0
        let minutes = 0
        let seconds = 0
        let from = Math.floor(new Date(date2).getTime() / 1000)
        let to = Math.floor(new Date(date1).getTime() / 1000)
        let different = from - to

        hours = Math.floor(different / 3600)
        minutes = Math.floor((different - (hours * 3600)) / 60)
        seconds = different - (hours * 3600) - (minutes * 60)

        if(hours < 10) hours = '0' + hours
        if(minutes < 10) minutes = '0' + minutes
        if(seconds < 10) seconds = '0' + seconds

        if(hours=='00') return `${minutes}:${seconds}`
        else return `${hours}:${minutes}:${seconds}`
    }

    // общее количество секунд
    get_seconds(date1, date2){
        if(!date1) return null
        if(!date2) return null

        let from = Math.floor(new Date(date2).getTime() / 1000)
        let to = Math.floor(new Date(date1).getTime() / 1000)
        let different = from - to
        return different
    }

    // секунды в таймер
    get_timer_from_seconds(ml_seconds){
        if(!ml_seconds || ml_seconds < 0) return null

        let seconds = Math.floor(ml_seconds/1000)
        let hours = Math.floor(seconds / 3600)
        let minutes = Math.floor((seconds - (hours * 3600)) / 60)
        let seconds_ = seconds - (hours * 3600) - (minutes * 60)

        if(hours < 10) hours = '0' + hours
        if(minutes < 10) minutes = '0' + minutes
        if(seconds_ < 10) seconds_ = '0' + seconds_

        if(hours=='00') return `${minutes}:${seconds_}`
        else return `${hours}:${minutes}:${seconds_}`
    }

    // секунды в минуты : часы : дни
    get_minutes_from_seconds(seconds){
        if(!seconds || seconds < 0) return null
        let minutes = Math.floor(seconds / 60)
        let hours = Math.floor(minutes / 60)
        let days = Math.floor(hours / 24)
        return { minutes: minutes, hours: hours, days: days }
    }

    format_card(card){
        if(!card) return ''
        if(card.length < 16) return card
        let mask = '#### #### #### ####'
        let i = 0, v = card.toString();
        return mask.replace(/#/g, _ => v[i++])
    }

    get_severity_status (status, lang = 'en') {
        switch (status) {
            case 'canceled':
                if(lang=='ru'){
                    return 'отменен';
                }else{
                    return 'canceled';
                }
            case 'completed':
                if(lang=='ru'){
                    return 'выполнен';
                }else{
                    return 'completed';
                }
            case 'approved':
                if(lang=='ru'){
                    return 'подтвержден';
                }else{
                    return 'approved';
                }
            case 'rejected':
                if(lang=='ru'){
                    return 'отклонен';
                }else{
                    return 'rejected';
                }
            case 'closed':
            case 'failed':
                if(lang=='ru'){
                    return 'закрыт';
                }else{
                    return 'closed';
                }
            case 'created':
            case 'reserved':
                if(lang=='ru'){
                    return 'создан';
                }else{
                    return 'created';
                }
            case 'process':
            case 'processing':
                if(lang=='ru'){
                    return 'в процессе';
                }else{
                    return 'process';
                }
            case 'pending':
            case 'confirmation':
                if(lang=='ru') return 'Подтверждение'
                else return 'pending'
            case 'moderation':
                return 'модерация';
            case 'expired':
                if(lang=='ru'){
                    return 'истек';
                }else{
                    return 'expired';
                }
            default:
                return status;
        }
    }

    get_severity_from_status (status) {
        switch (status) {
            case 'completed':
            case 'success':
                return 'success';
            case 'reverted':
                return 'contrast';
            case 'created':
            case 'process':
                return 'info';
            case 'closed':
            case 'canceled':
            case 'failed':
                return 'danger';
            case 'expired':
            case 'moderation':
            case 'reserved':
            case 'freezed':
            case 'risk':
                return 'warn';
            default:
                return '';
        }
    }

    payment_system_label (system) {
        switch (system) {
            case 'adv':
                return 'AdvCash';
            case 'imoney':
                return 'Intellect Money';
            case 'paypal':
                return 'PayPal';
            case 'sbp_tinkoff':
                return 'СБП';
            case 'merchant':
                return 'Оплата на карту';
            case 'binance':
                return 'Binance';
            case 'card':
                return 'Оплата на карту';
            default:
                return system;
        }
    }

    get_severity_deal (label, lang = 'en') {
        switch (label) {
            case 'seller':
                if(lang=='ru'){
                    return 'продажа';
                }else{
                    return 'seller';
                }
            case 'buyer':
                if(lang=='ru'){
                    return 'покупка';
                }else{
                    return 'buyer';
                }
            default:
                return label;
        }
    }

    get_bank_by_code(code, bank_obj){
        if(!code) return null
        if(!bank_obj) return null
        if(!bank_obj[code]) return null
        return bank_obj[code]
    }

    get_pays_by_code(code, arrPays){
        if(!code) return null
        if(!arrPays) return null
        let pay = arrPays.find((item)=>{
            return item.code == code
        })
        if(pay) return pay
        else return null
    }

    get_bank_title (code, bank_obj, lang = 'en') {
        if(!code || !bank_obj) return code
        if(code == 'internal') {
            if(lang=='ru') return 'Внутренний счет'
            else return 'Internal account'
        }
        const bank = this.get_bank_by_code(code, bank_obj)
        if(bank && bank.titles) 
            return (bank.titles[lang]) ? bank.titles[lang] : (bank.titles['en']) ? bank.titles['en'] : code
        else 
            return code
    }

    get_bank_description (code, bank_obj, lang = 'en') {
        if(!code || !bank_obj) return code
        const bank = this.get_bank_by_code(code, bank_obj)
        if(bank && bank.descriptions)
            return (bank.descriptions[lang]) ? bank.descriptions[lang] : (bank.descriptions['en']) ? bank.descriptions['en'] : ''
        else
            return code
    }

    get_pays_title(code, pays_obj, lang = 'en') {
        if(!code || !pays_obj) return code
        const pay = this.get_pays_by_code(code, pays_obj)
        if(pay && pay.titles)
            return (pay.titles[lang]) ? pay.titles[lang] : (pay.titles['en']) ? pay.titles['en'] : code
        else
            return code
    }

    get_bank_image (code, bank_obj) {
        if(!code || !bank_obj) return '/images/svg/banks/other.svg'
        const bank = this.get_bank_by_code(code, bank_obj)
        if(bank && bank.image) return bank.image
        else return '/images/svg/banks/other.svg'
    }

    get_pays_image (code, pays_obj) {
        if(!code || !pays_obj) return '/images/svg/pays/other.svg'
        const bank = this.get_pays_by_code(code, pays_obj)
        if(bank && bank.image) return bank.image
        else return '/images/svg/pays/other.svg'
    }

    GetCurrencyImage(code, curObj) {
        if(!code || !curObj) return '/images/svg/currencies/other.svg'
        if(code=='usdt_trc' || code=='usdt_bsc') code = 'usdt'
        const currency = curObj.find(item => item.code === code)
        if(currency && currency.image) return currency.image
        else return '/images/svg/currencies/other.svg'
    }

    GetNetworkImage(network){
        if(!network) return '/images/svg/networks/other.svg'
        switch (network) {
            case 'erc20':
                return '/images/svg/networks/eth.svg'
            case 'bep20':
                return '/images/svg/networks/bsc.svg'
            case 'trc20':
                return '/images/svg/networks/trc.svg'
            case 'sol':
                return '/images/svg/networks/sol.svg'
            default:
                return '/images/svg/networks/other.svg'
        }
    }

    GetCurrencyLabel(code) {
        switch (code) {
            case 'usdt_bsc':
                return 'USDTb';
            case 'usdt_erc':
                return 'USDTe';
            case 'usdt_trc':
                return 'USDTt';
            default:
                return code.toUpperCase();
        }
    }

    cutUserId(string){
        if(string && string.length > 5){
            return string.slice(18)
        }else{
            return ''
        }
    }

    get_card_type(card){
        if(!card) return card
        
        switch (card) {
            case 'card':
                return 'карта'
            case 'sbp':
                return 'СБП'
            case 'account':
                return 'счет'
            case 'stock':
                return 'биржа'
            case 'crypto':
                return 'криптовалюта'
            default:
                return card
        }
    }


    get_os() {
        var userAgent = window.navigator.userAgent,
            platform = window.navigator?.userAgentData?.platform || window.navigator.platform,
            macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K', 'macOS'],
            windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
            iosPlatforms = ['iPhone', 'iPad', 'iPod'],
            os = null;

        if (macosPlatforms.indexOf(platform) !== -1) {
            os = 'Mac OS';
        } else if (iosPlatforms.indexOf(platform) !== -1) {
            os = 'iOS';
        } else if (windowsPlatforms.indexOf(platform) !== -1) {
            os = 'Windows';
        } else if (/Android/.test(userAgent)) {
            os = 'Android';
        } else if (/Linux/.test(platform)) {
            os = 'Linux';
        }

        return os;
    }

    is_mobile() {
        var userAgent = window.navigator.userAgent,
            platform = window.navigator?.userAgentData?.platform || window.navigator.platform,
            macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K', 'macOS'],
            windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
            iosPlatforms = ['iPhone', 'iPad', 'iPod'],
            os = null;

        if (macosPlatforms.indexOf(platform) !== -1) {
            os = 'Mac OS';
        } else if (iosPlatforms.indexOf(platform) !== -1) {
            os = 'iOS';
        } else if (windowsPlatforms.indexOf(platform) !== -1) {
            os = 'Windows';
        } else if (/Android/.test(userAgent)) {
            os = 'Android';
        } else if (/Linux/.test(platform)) {
            os = 'Linux';
        }

        if(os=='Android' || os=='iOS'){
            return true
        }else{
            return false
        }
    }

    screen_size(that) {
        if(!that.window) return 'xl'
        if(that.window.width < 576)     return 'xs'
        if(that.window.width < 768)     return 'sm'
        if(that.window.width < 992)     return 'md'
        if(that.window.width < 1200)    return 'lg'
        if(that.window.width < 1536)    return 'xl'
        if(that.window.width >= 1536)   return '2xl'
        return '2xl'
    }

    copy_clipboard(text){
        var textArea = document.createElement("textarea");
        textArea.style.position = 'fixed';
        textArea.style.top = 0;
        textArea.style.left = 0;
        textArea.style.width = '2em';
        textArea.style.height = '2em';
        textArea.style.padding = 0;
        textArea.style.border = 'none';
        textArea.style.outline = 'none';
        textArea.style.boxShadow = 'none';
        textArea.style.background = 'transparent';
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
            var successful = document.execCommand('copy');
        } catch (err) {
            console.log('Oops, unable to copy');
        }
        document.body.removeChild(textArea);
    }

    // getUtm method

    getUtm(){
        const url = new URL(window.location.href)
        const utm_source =    (url.searchParams.get('utm_source')) ? url.searchParams.get('utm_source') : ''
        const utm_medium =    (url.searchParams.get('utm_medium')) ? url.searchParams.get('utm_medium') : ''
        const utm_campaign =  (url.searchParams.get('utm_campaign')) ? url.searchParams.get('utm_campaign') : ''
        const utm_content =   (url.searchParams.get('utm_content')) ? url.searchParams.get('utm_content') : ''
        const utm_term =      (url.searchParams.get('utm_term')) ? url.searchParams.get('utm_term') : ''
        const utm = {
            utm_source: utm_source,
            utm_medium: utm_medium,
            utm_campaign: utm_campaign,
            utm_content: utm_content,
            utm_term: utm_term,
        }
        if(utm_source || utm_medium || utm_campaign || utm_content || utm_term){
            return utm
        } 
        return null
    }

    createUtmUrl(url, utm){
        let utm_url = url
        if(utm){
            if(utm.utm_source){
                utm_url += '&utm_source='+utm.utm_source
            }
            if(utm.utm_medium){
                utm_url += '&utm_medium='+utm.utm_medium
            }
            if(utm.utm_campaign){
                utm_url += '&utm_campaign='+utm.utm_campaign
            }
            if(utm.utm_content){
                utm_url += '&utm_content='+utm.utm_content
            }
            if(utm.utm_term){
                utm_url += '&utm_term='+utm.utm_term
            }
        }
        return utm_url
    }

    // генерация utm меток для sendpulse + fbclid из facebook + gaClientId из GA
    createUtmUrlSendpulse(url, utm, fbclid=null, yandexclid=null, gaClientId=null){
        let utm_url = url
        if(utm){
            if(utm.utm_source){
                utm_url += '|utm_source='+utm.utm_source
            }
            if(utm.utm_medium){
                utm_url += '|utm_medium='+utm.utm_medium
            }
            if(utm.utm_campaign){
                utm_url += '|utm_campaign='+utm.utm_campaign
            }
            if(utm.utm_content){
                utm_url += '|utm_content='+utm.utm_content
            }
            if(utm.utm_term){
                utm_url += '|utm_term='+utm.utm_term
            }
        }
        if(fbclid){
            utm_url += '|fbclid='+fbclid
        }
        if(yandexclid){
            utm_url += '|yandexclid='+yandexclid
        }
        if(gaClientId){
            utm_url += '|ga_client_id='+gaClientId
        }
        return utm_url
    }

    // utm's object
    get_utm(){
        const url = new URL(window.location.href)
        const utm_source =    (url.searchParams.get('utm_source')) ? url.searchParams.get('utm_source') : ''
        const utm_medium =    (url.searchParams.get('utm_medium')) ? url.searchParams.get('utm_medium') : ''
        const utm_campaign =  (url.searchParams.get('utm_campaign')) ? url.searchParams.get('utm_campaign') : ''
        const utm_content =   (url.searchParams.get('utm_content')) ? url.searchParams.get('utm_content') : ''
        const utm_term =      (url.searchParams.get('utm_term')) ? url.searchParams.get('utm_term') : ''
        const utm = {
            utm_source: utm_source,
            utm_medium: utm_medium,
            utm_campaign: utm_campaign,
            utm_content: utm_content,
            utm_term: utm_term,
        }
        if(utm_source || utm_medium || utm_campaign || utm_content || utm_term){
            return utm
        } 
        return null
    }

    get_ref(){
        const url = new URL(window.location.href)
        const ref = (url.searchParams.get('ref')) ? url.searchParams.get('ref') : ''
        return ref
    }

    // берем utm метки из store, coockie, localstorage
    get_utm_from_meta(store = null, cookie = null, localstorage = null){
        let utm = {
            utm_source: null,
            utm_medium: null,
            utm_campaign: null,
            utm_term: null,
            utm_content: null,
        }
        if(!store && !cookie && !localstorage) return utm

        // записываем utm метки в переменные            
        let utm_source = null
        let utm_medium = null
        let utm_campaign = null
        let utm_term = null
        let utm_content = null
    
        // utm_source
        try { utm_source = store.utm_source } catch{}
        if(!utm_source) try { utm_source = cookie.utm_source } catch{}
        if(!utm_source) try { utm_source = localstorage.utm_source } catch{}
        if(!utm_source) try { utm_source = null } catch{}

        // utm_medium
        try { utm_medium = store.utm_medium } catch{}
        if(!utm_medium) try { utm_medium = cookie.utm_medium } catch{}
        if(!utm_medium) try { utm_medium = localstorage.utm_medium } catch{}
        if(!utm_medium) try { utm_medium = null } catch{}

        // utm_campaign
        try { utm_campaign = store.utm_campaign } catch{}
        if(!utm_campaign) try { utm_campaign = cookie.utm_campaign } catch{}
        if(!utm_campaign) try { utm_campaign = localstorage.utm_campaign } catch{}
        if(!utm_campaign) try { utm_campaign = null } catch{}

        // utm_term
        try { utm_term = store.utm_term } catch{}
        if(!utm_term) try { utm_term = cookie.utm_term } catch{}
        if(!utm_term) try { utm_term = localstorage.utm_term } catch{}
        if(!utm_term) try { utm_term = null } catch{}
       
        // utm_content
        try { utm_content = store.utm_content } catch{}
        if(!utm_content) try { utm_content = cookie.utm_content } catch{}
        if(!utm_content) try { utm_content = localstorage.utm_content } catch{}
        if(!utm_content) try { utm_content = null } catch{}

        utm = {
            utm_source: utm_source,
            utm_medium: utm_medium,
            utm_campaign: utm_campaign,
            utm_term: utm_term,
            utm_content: utm_content,
        }
        return utm
    }

    // берем ref метки из store, coockie, localstorage
    get_ref_from_meta(store = null, cookie = null, localstorage = null){
        let ref = null
        try { ref = store } catch{}
        if(!ref) try { ref = cookie } catch{}
        if(!ref) try { ref = localstorage } catch{}
        if(!ref) try { ref = null } catch{}
        return ref
    }

    /**
     * Получает значение параметра из cookies по его имени.
     * @param {string} name - Имя параметра.
     * @returns {string|null} - Значение параметра или null, если параметр не найден.
     */
    getCookieByName(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
        return null;
    }

    // Параметр fbp из url или cookies
    getFbp(){
        const cookie_fbp = this.getCookieByName('_fbp')
        if(cookie_fbp) return cookie_fbp
        return null
    }

    // Параметр fbс из url или cookies
    getFbc(){
        const url_fbp = this.getByParam(window.location.href, 'fbclid')
        if(url_fbp) {
            const fbc = this.formatFbpFbc(url_fbp)
            return fbc
        }
        const cookie_fbc = this.getCookieByName('_fbc')
        if(cookie_fbc) return cookie_fbc
        return null
    }

    // Параметр GA client_id из cookie _ga
    getGaClientId(){
        const gaCookie = this.getCookieByName('_ga')
        if(!gaCookie || typeof gaCookie !== 'string') return null

        const parts = gaCookie.split('.')
        if(parts.length < 4) return null

        const clientId = parts.slice(-2).join('.')
        return clientId || null
    }

    // добавим приставку к параметрам fbp и fbc
    formatFbpFbc(value){
        if(!value) return null
        if(typeof(value)!='string') return null
        const timestamp = Math.floor(new Date() / 1000)
        return `fb.1.${timestamp}.${value}`
    }

    getUserAgent(){
        return (navigator && navigator.userAgent) ? navigator.userAgent : null
    }

    isUserInGroup (group, objGroups) { 
        if(!group) return false
        if(!objGroups) return false
        let groups = [], in_group = false
        if(objGroups && typeof(objGroups) == 'object') groups = Array.from(objGroups) 
        else return false
        if(groups.includes(group)) in_group = true
        return (in_group) ? true : false
    }

    get_dates_range (start, end) {
        let dates = []
        let date = new Date(start) // 1 march
        let end_date = new Date(end) // 30 march
        while(date <= end_date){
            let formatDate = date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate()
            dates.push(formatDate)
            date = new Date(date.setDate(date.getDate() + 1))
        }
        return dates
    }

    getTgUserObject (url) {
        let user = null
        let user_str = url.split('&user:')[1]
        if(user_str){
            user_str = user_str.split('&')[0]
            user = JSON.parse(user_str)
        }
        return user
    }

    getUrl(){
        return (window.location && window.location.href) ? window.location.href : null
    }

    splitTgData(data, start_param){

        if(!data) return null
        if(typeof(data)!='string') return null
        let params = {}
        let params_arr = data.split('&')
        if(params_arr.length==0) return null
        params_arr.forEach((item)=>{
            let param = item.split('=')
            params[param[0]] = param[1]
        })
        if(params[start_param]) return params[start_param]
        else return null
    }

    getUrlParams (url) {
        if(!url) return null
        if(typeof(url)!='string') return null
        let params = {}
        let params_arr = url.split('?')
        if(params_arr.length==0) return null
        let url_params = params_arr[1]
        if(!url_params) return null
        let params_arr_ = url_params.split('&')
        if(params_arr_.length==0) return null

        params_arr_.forEach((item)=>{
            let param = item.split('=')
            params[param[0]] = param[1]
        })
        return params
    }

    getByParam (url, param) {
        if(!url) return null
        if(typeof(url)!='string') return null
        if(!param) return null
        let params = this.getUrlParams(url)
        if(!params) return null
        for (const [key, value] of Object.entries(params)) {
            if(key==param) return value
        }
        return null
    }

    splitParams (param) {
        if(!param) return null
        let params = {}
        let params_arr = param.split('-')
        if(params_arr.length==2){
            params['key'] = params_arr[0]
            params['value'] = params_arr[1]
            return params
        } else {
            return null
        }   
    }

    getWalletNetworkTitle (network) {
        if(!network) return null
        switch (network) {
            case 'bep20':
                return 'BEP20'
            case 'erc20':
                return 'ERC20'
            case 'trc20':
                return 'TRC20'
            case 'ton':
                return 'TON'
            default:
                return network
        }
    }

    GetScanHashUrl (hash, network, test=false) {
        if(!network || !hash) return null
        switch (network) {
            case 'bep20': 
                if(test) return `https://testnet.bscscan.com/tx/${hash}`
                else return `https://bscscan.com/tx/${hash}`
            case 'erc20':
                if(test) return `https://testnet.etherscan.io/tx/${hash}`
                else return `https://etherscan.io/tx/${hash}`
            case 'trc20':
                if(test) return `https://nile.tronscan.org/#/transaction/${hash}`
                else return `https://tronscan.org/#/transaction/${hash}`
            case 'ton':
                if(test) return `https://testnet.tonscan.org/tx/${hash}`
                else return `https://tonscan.org/tx/${hash}`
            default:
                return null
        }
    }

    get_percent (value) {
        if(!value) return 0
        let result = value * 100
        return result
    }
    
    GetSystemWalletName(value, wallet_id, walletList=[]){
        if(!value) return null
        if(!walletList || walletList.length==0) return null
        if(wallet_id && value == wallet_id) return 'current'

        const wallet = walletList.find(wallet => {
            if(wallet.id && wallet.id == value) return true
            return false
        })
        if(wallet) return wallet.type
        return null
    }

    // определяем тип кошелька по id аккаунта
    GetSystemAccountName(value, account_id, walletList=[]){
        if(!value) return null
        if(!walletList || walletList.length==0) return null
        if(account_id && value == account_id) return 'current'

        const wallet = walletList.find(wallet => {
            if(wallet.accounts && wallet.accounts.length > 0 && wallet.accounts.includes(value)) return true
            return false
        })
        if(wallet) return wallet.ext_type
        return null
    }

    GetClassByLabel(label){
        if(!label) return ''
        if(label == 'virtual') return 'surface-100 text-600'
        if(label == 'external_deposit') return 'surface-100 text-600'
        if(label == 'virtual_debit') return 'surface-600 text-100'
        if(label == 'current') return 'bg-red-100 text-red-600'
        if(label == 'deposit') return 'bg-green-100 text-green-600'
        if(label == 'service') return 'bg-blue-100 text-blue-600'
        if(label == 'vcard') return 'bg-blue-50 text-blue-500'
        if(label == 'transfer') return 'bg-green-300 text-white'
        if(label == 'merchant') return 'bg-blue-100 text-blue-600'
        if(label == 'partner') return 'surface-100 text-600'
        if(label == 'comission') return 'bg-green-50 text-green-600'
        if(label == 'liquidity') return 'bg-orange-100 text-orange-700'
        if(label == 'withdraw') return 'bg-yellow-100 text-yellow-700'
        if(label == 'topup') return 'bg-green-400 text-white'
        if(label == 'vendor') return 'bg-purple-400 text-white'
        if(label == 'freeze') return 'bg-blue-400 text-white'
        if(label == 'fund') return 'bg-red-400 text-white'
        return ''
    }

    GetWalletNameByLabel(label){
        if(!label) return null
        switch (label) {
            case 'current':
                return label
            case 'virtual':
                return 'Виртуальный'
            case 'virtual_debit':
                return 'Дебетовый'
            case 'deposit':
                return 'Пополнение'
            case 'service':
                return 'Сервисный'
            case 'vcard':
                return 'Карточный'
            case 'transfer':
                return 'Перевод'
            case 'merchant':
                return 'Торговый'
            case 'partner':
                return 'Партнерский'
            case 'comission':
                return 'Комиссия'
            case 'liquidity':
                return 'Ликвидность'
            case 'withdraw':
                return 'Вывод'
            case 'topup':
                return 'Пополнение'
            case 'vendor':
                return 'Поставщик'
            case 'freeze':
                return 'Заморозка'
            case 'fund':
                return 'Фонд'
            default:
                return label
        }
    }

    SetTgAppHeadColor(color, darkMode=false){
        try {
            if(!color) return
            const light = {
                white: '#ffffff',
                gray: '#eceff3',
            }
            const dark = {
                white: '#1c1c1c',
                gray: '#111111',
            }
            
            if(!dark[color] && !light[color]) return

            if(window.Telegram && window.Telegram.WebApp){
                if(darkMode) try { window.Telegram.WebApp.setHeaderColor(dark[color]) } catch {}
                else         try { window.Telegram.WebApp.setHeaderColor(light[color]) } catch {}
            }
        } catch {}
    }
    
    SetTgAppHeadColorCustom(color){
        if(!color) return
        if(!window.Telegram || !window.Telegram.WebApp) return
        try { window.Telegram.WebApp.setHeaderColor(color) } catch {}
    }

    SetTgAppBackButton( show = true ){
        try {
            if(window.Telegram && window.Telegram.WebApp){
                if(show) try { window.Telegram.WebApp.BackButton.show() } catch {}
                else     try { window.Telegram.WebApp.BackButton.hide() } catch {}
            }
        } catch {}
    }

    SetTgAppBackgroundColor(darkMode=false){
        try {          
            if(window.Telegram && window.Telegram.WebApp){
                if(darkMode) try { window.Telegram.WebApp.setBackgroundColor('#1c1c1c') } catch {}
                else         try { window.Telegram.WebApp.setBackgroundColor('#ffffff') } catch {}
            }
        } catch {}
    }

    getWalletNameByType(type, lang='en'){
        if(!type) return null
        switch (type) {
            case 'partner':
                if(lang=='ru') return 'Партнерский счет'
                else return 'Partner account'
            case 'merchant':
                if(lang=='ru') return 'Торговый счет'
                else return 'Merchant account'
            case 'vcard':
                if(lang=='ru') return 'Карточный счет'
                else return 'Card account'
            case 'deposit':
                if(lang=='ru') return 'Счет пополнения'
                else return 'Deposit account'
            default:
                return type
        }
    }

    GetUserTag(value){
        if(!value) return null
        if(value == 'zero_transfers') return 'Без переводов'
        if(value == 'bill') return 'Счет'
        if(value == 'bronze') return 'до 1000'
        if(value == 'silver') return '1k-3k'
        if(value == 'gold') return '3k-5k'
        if(value == 'platinum') return '>5k'
        if(value == 'active_7') return 'Акт. за неделю'
        if(value == 'active_30') return 'Акт. за месяц'
        if(value == 'active_90') return 'Акт. за 3 месяца'
        return value
    }
    GetUserTagColor(value){
        if(!value) return null
        if(value == 'zero_transfers') return 'surface-200 text-500'
        if(value == 'bill') return 'bg-primary text-white'
        if(value == 'bronze') return 'bg-orange-100 text-orange-500'
        if(value == 'silver') return 'bg-orange-200 text-orange-600'
        if(value == 'gold') return 'bg-orange-300 text-orange-700'
        if(value == 'platinum') return 'bg-orange-400 text-orange-800'
        if(value == 'active_7') return 'bg-green-100 text-green-500'
        if(value == 'active_30') return 'bg-green-200 text-green-600'
        if(value == 'active_90') return 'bg-green-300 text-green-700'
        return null
    }

    // TODO: доделать
    GetValidCurrency(value){
        if(!value) return null
        else if(value == 'usdt') return 'usd'
        else return value
    }

    getVendorName(id){
        if(!id) return null
        switch (id) {
            case '9636b753-351a-4b3c-80a9-69adacae70a1':
                return 'Online'
            case '8c871fa8-37a0-41f5-afa9-1e68d95aa2d9':
                return 'ApplePay'
            default:
                return id
        }
    }

    getProgramName(id){
        if(!id) return null
        switch (id) {
            case '36054473-1813-44f7-b667-4e2cba5ca8c8':
                return 'USD MC Services+'
            case '2e401f4d-9577-4d28-9f04-2a2fcaef4bab':
                return 'USD MC Apple/Google'

            case 'P00PD20251024007073':
                return 'cardspro_program_1'
            case 'P00PD20260302009335':
                return 'cardspro_program_2'
            case 'W02111035':
                return 'cardspro_program_3'
            case 'W02111036':
                return 'cardspro_program_4'
            case 'S00E0000000':
                return 'cardspro_program_5'
            case 'S00E0000001':
                return 'cardspro_program_6'
            case 'S00SV000003':
                return 'cardspro_program_7'
            case 'S00E0W00008':
                return 'cardspro_program_8'
            case 'S00E0W00009':
                return 'cardspro_program_9'
            case 'W02111030':
                return 'cardspro_program_10'
            case 'W02111048':
                return 'cardspro_program_11'
            default:
                return id
        }
    }

}